import React, {useEffect} from 'react';
import Tab from "react-bootstrap/lib/Tab";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import ImportPapersTab from "./components/ImportPapersTab";
import BrochureTab from "./components/BrochureTab";
import WhovaTab from "./components/WhovaTab";
import PublishTab from "./components/PublishTab";

function AdminPage(props) {
    useEffect(() => {
        props.updateHeader("Admin Panel", "")
    }, []);

    return (
        <Tab.Container id="left-tabs-example" defaultActiveKey="1">
            <Row className="clearfix">
                <Col sm={3}>
                    <Nav bsStyle="pills" stacked>
                        <NavItem eventKey="1"><h4>Import papers</h4></NavItem>
                        <NavItem eventKey="2"><h4>Session creation</h4></NavItem>
                        <NavItem eventKey="3"><h4>Brochure</h4></NavItem>
                        <NavItem eventKey="4"><h4>Whova</h4></NavItem>
                        <NavItem eventKey="5"><h4>Publish</h4></NavItem>
                    </Nav>
                </Col>
                <Col sm={6}>
                    <Tab.Content animation>
                        <Tab.Pane eventKey="1">
                            <ImportPapersTab user={props.user}/>
                        </Tab.Pane>
                        <Tab.Pane eventKey="2">Tab 2 content</Tab.Pane>
                        <Tab.Pane eventKey="3"><BrochureTab/></Tab.Pane>
                        <Tab.Pane eventKey="4"><WhovaTab/></Tab.Pane>
                        <Tab.Pane eventKey="5"><PublishTab user={props.user}/></Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    )
}

export default AdminPage
